import React, { useState, useEffect } from "react";
import { Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { vehicle_type_option } from "../../utilities";
import Select from "react-select";
import { createServiceApi, updateServiceApi } from "../../services/ServiceApi";
import { FiTrash2 } from "react-icons/fi";
import { IoMdAdd } from "react-icons/io";

const AddMultipleVehicleServiceModal = ({
  visible,
  onClose,
  onAfterSubmit,
}) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: "" });
  const [vehicleService, setVehicleService] = useState([
    { vehicle_type: null, price: "" },
  ]);
  const [error, setError] = useState({});
  const [vehicleError, setVehicleError] = useState([]);

  useEffect(() => {
    if (visible) handleReset();
  }, [visible]);

  const handleReset = () => {
    setForm({ name: "" });
    setVehicleService([{ vehicle_type: null, price: "" }]);
    setError({});
    setVehicleError([]);
  };

  const handleServiceNameChange = (e) => {
    setForm({ ...form, name: e.target.value });
    if (e.target.value && error.name) {
      setError((prev) => ({ ...prev, name: "" }));
    }
  };

  const handleVehicleChange = (index, selectedOption) => {
    const newList = [...vehicleService];
    newList[index].vehicle_type = selectedOption;
    setVehicleService(newList);

    if (selectedOption && vehicleError[index]?.vehicle_type) {
      const vehiclesError = [...vehicleError];
      vehiclesError[index].vehicle_type = "";
      setVehicleError(vehiclesError);
    }
  };

  const handlePriceChange = (index, e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      const newList = [...vehicleService];
      newList[index].price = value;
      setVehicleService(newList);

      if (value && vehicleError[index]?.price) {
        const vehiclesError = [...vehicleError];
        vehiclesError[index].price = "";
        setVehicleError(vehiclesError);
      }
    }
  };

  const addVehicleRow = () => {
    setVehicleService([...vehicleService, { vehicle_type: null, price: "" }]);
  };

  const removeVehicleRow = (index) => {
    const newList = [...vehicleService];
    newList.splice(index, 1);
    setVehicleService(newList);
  };

  const validateForm = () => {
    let newError = [];
    let serviceError = {};
    if (!form.name) {
      serviceError.name = "Service Name is required";
    }
    vehicleService.forEach((item, idx) => {
      let error = {};
      if (!item.vehicle_type) {
        error.vehicle_type = "Vehicle type required";
      }
      if (!item.price) {
        error.price = "Price required";
      }
      if (Object.keys(error).length > 0) {
        newError[idx] = error;
      }
    });
    setError(serviceError);
    setVehicleError(newError);
    return Object.keys(serviceError).length === 0 && newError.length == 0;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    const payload = {
      name: form.name,
      services: vehicleService.map((v) => ({
        vehicle_type: v?.vehicle_type?.value || "",
        price: v?.price || "",
      })),
    };

    addService(payload);
  };
  const addService = (payload) => {
    setLoading(true);
    createServiceApi(payload)
      .then((res) => {
        toast.success("Service Created Successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <Modal show={visible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Add Service</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row g-2 p-1">
          <div className="col-12 mb-1">
            <label className="form-label text-dark">Service Name</label>
            <input
              type="text"
              className={`form-control ${error?.name ? "is-invalid" : ""}`}
              value={form.name}
              placeholder="e.g. FoamWash"
              onChange={handleServiceNameChange}
            />
            {error?.name && <small className="text-danger">{error.name}</small>}
          </div>

          {vehicleService.map((item, idx) => (
            <div className="col-12 row g-2 mt-0" key={idx}>
              <div className="col">
                <label className="form-label text-dark">Vehicle</label>
                <Select
                  classNamePrefix="select"
                  placeholder="Select Vehicle"
                  options={
                    vehicle_type_option.filter(
                      (v) =>
                        !vehicleService?.some(
                          (s) => s?.vehicle_type?.value === v?.value
                        )
                    ) || []
                  }
                  value={item.vehicle_type}
                  onChange={(option) => handleVehicleChange(idx, option)}
                />
                {vehicleError[idx]?.vehicle_type && (
                  <small className="text-danger">
                    {vehicleError[idx]?.vehicle_type || "-"}
                  </small>
                )}
              </div>
              <div className="col">
                <label className="form-label text-dark">Price</label>
                <input
                  type="text"
                  className={`form-control ${
                    vehicleError[idx]?.price ? "is-invalid" : ""
                  }`}
                  value={item.price}
                  placeholder="e.g. ₹4000"
                  onChange={(e) => handlePriceChange(idx, e)}
                />
                {vehicleError[idx]?.price && (
                  <small className="text-danger">
                    {vehicleError[idx]?.price || "-"}
                  </small>
                )}
              </div>
              <div className="col-auto align-self-start">
                <div className="d-flex gap-1">
                  {vehicleService.length > 1 && (
                    <span
                      className="btn stylish-transparent-btn"
                      style={{ padding: "0.5rem", marginTop: "2.3rem" }}
                      onClick={() => removeVehicleRow(idx)}
                    >
                      {" "}
                      <FiTrash2 className="text-dark" size="14" />{" "}
                    </span>
                  )}
                  {vehicleService.length - 1 == idx && (
                    <button
                      className="btn stylish-transparent-btn"
                      style={{ padding: "0.5rem", marginTop: "2.3rem" }}
                      onClick={addVehicleRow}
                      disabled={
                        vehicle_type_option?.length == vehicleService?.length
                      }
                    >
                      {" "}
                      <IoMdAdd className="text-dark" size="14" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
          {/* <div className="col-12">
            <button
              className="btn stylish-transparent-btn"
              style={{ padding: "0.28rem 0.5rem" }}
              onClick={addVehicleRow}
              disabled={vehicle_type_option?.length==vehicleService?.length}
            >
              {" "}
              <IoMdAdd className="text-dark me-1" size="16" />
              Vehicle
            </button>
          </div> */}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-outline-dark" onClick={onClose}>
          Cancel
        </button>
        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading && <Spinner animation="border" size="sm" className="me-2" />}
          Submit
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddMultipleVehicleServiceModal;
